import { HttpClient } from '../HttpClient';
/**
 * * POST Job Request Synchronization with Manatal
 */
export const PostJobRequestSynchronization = async () => {
  try {
    const { data } = await HttpClient.post(
      'api/jobrequisitions/synchronization',
      { jobRequestIds: [] }
    );
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
